import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { RouteChildrenProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as audioVideoReceiptActions from '../../../actions/audio-video/receipt';
import { InmateAccountPayment } from '../../../models/InmateAccountPayment';
import { IAppState } from '../../../reducers';
import Confirmation from '../../Checkout/AudioVideo/Confirmation';
import ErrorMessage from '../../ErrorMessage';
import PageTitle from '../../PageTitle';

interface IAudioVideoReceiptUrlParams {
  id?: string
}

interface IAudioVideoReceiptRouteState {
  payment?: InmateAccountPayment
}

const AudioVideoReceipt: React.FC<RouteChildrenProps<IAudioVideoReceiptUrlParams, IAudioVideoReceiptRouteState>> = props => {
  const state = useSelector((appState: IAppState) => ({
    audioVideo: appState.audioVideo,
    facilities: appState.common.facilities
  }));
  const dispatch: ThunkDispatch<IAppState, undefined, Action> = useDispatch();

  useEffect(() => {
    dispatch(audioVideoReceiptActions.loadPayment(props.match.params.id ?? state.audioVideo.receipt?.payment?.id));

    return function cleanupAudioVideoReceipt() {
      dispatch(audioVideoReceiptActions.reset());
    };
  }, []);

  // If we still have the receipt email address (since it isn't persisted with the payment), we will display it. Otherwise it'll be hidden
  const receiptEmailAddress = state.audioVideo.receipt.receiptEmailAddress;

  const facility = (state.facilities || []).filter(f => f.id == state.audioVideo.receipt.payment?.inmate?.facility?.id).pop();

  return (
    <main className="container align-items-top justify-content-center mt-5 mt-lg-3 pt-4">
      <section className="no-gutters">
        <PageTitle title="Inmate Wallet - Voice & Video Calls Only Payment" />

        {state.audioVideo.receipt.paymentLoadError ?
          <ErrorMessage
            error={state.audioVideo.receipt.paymentLoadError}
            httpCodeMessages={{
              404: 'This receipt was not found'
            }}
            /> :
          (
            state.audioVideo.receipt.paymentLoading || !state.audioVideo.receipt.payment ?
              <div className="row d-flex justify-content-center">
                <div className="col-md-6">
                  <Skeleton height={700} className="m-5" />
                </div>
              </div> :
              <Confirmation
                facility={facility}
                payment={state.audioVideo.receipt.payment}
                receiptEmailAddress={receiptEmailAddress}
                />
          )
        }
      </section>
    </main>
  )
}

export default AudioVideoReceipt;
